import React from "react";

import config from "./../config.js";

export default class DocumentSeries extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="container-fluid">
				<nav className="clearfix my-3">
					<h4 className="animated fadeInLeft"> 推荐序列 </h4>
				</nav>
				<h5>GE </h5>
					<table className="table table-striped table-bordered">
					  <thead className="thead-dark">
					    <tr>
					      <th scope="col">机型</th>
					      <th scope="col">版本</th>
					      <th scope="col">下载</th>
					    </tr>
					  </thead>
					  <tbody>
					    <tr>
					      <td scope="row">MR750</td>
					      <td>DV24_8CH</td>
					      <td><a href={`${config.union}/data/document/series/ABI1.0_GE_MR750_DV24_8CH.rar`} target="_blank"> <i className="fa fa-download"></i> 下载 </a></td>
					    </tr>
					    
					    <tr>
					      <td rowspan="2">MR750W</td>
					      <td>MP24_19CH</td>
					      <td><a href={`${config.union}/data/document/series/ABI1.0_GE_MR750W_Silent_MP24_19CH.rar`} target="_blank"> <i className="fa fa-download"></i> 下载 </a></td>
					    </tr>
					    <tr>
					      <td>DV24_8CH</td>
					      <td><a href={`${config.union}/data/document/series/ABI1.0_GE_MR750_DV24_8CH.rar`} target="_blank"> <i className="fa fa-download"></i> 下载 </a></td>
					    </tr>
					    <tr>
					      <td rowspan="2">MR750W</td>
					      <td>MP24_19CH</td>
					      <td><a href={`${config.union}/data/document/series/ABI1.0_GE_MR750W_Silent_MP24_19CH.rar`} target="_blank"> <i className="fa fa-download"></i> 下载 </a></td>
					    </tr>
					    <tr>
					      <td>DV24_8CH</td>
					      <td><a href={`${config.union}/data/document/series/ABI1.0_GE_MR750_DV24_8CH.rar`} target="_blank"> <i className="fa fa-download"></i> 下载 </a></td>
					    </tr>

					  </tbody>
					</table>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/apps/site/document_series.js